import React, { useState, useEffect,useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LogoutModel from './LogoutModel';
import { toast } from 'react-toastify';
import ReactTooltip from "react-tooltip";
import { Switch, useHistory, useLocation } from 'react-router-dom';
import { fncUndoCheckInPassengerApi, fncLoadFlightManifestDataForBoarding, fncGetTripStatus, fncBoardPassengers, fncUnBoardPassengers } from '../Utility/ApiCall.js';
import { flightManifestBoardingCredential, flightTripBoardingCredential, moduleAndLoginDivDisabled } from '../ReduxState';
import { mapToProp, searchPageIconsMapping, getSegmentsDetail, getIconForPassenger, shortcutKeyForBoardingsPage, shortcutKeysBoarding, fncFocusElementDependsOnPathLocation } from '../Utility/CommonFun';
import "react-datepicker/dist/react-datepicker.css";
import * as moment from 'moment';
import '../Scss/_boarding.scss';
import FocusLock from "react-focus-lock";

function Manifest() {
    const inputElementForSeat = useRef([]);
    const  seatmanagementsortref = useRef([]);
    const  bordorunboardref = useRef([]);
    const allselectref = useRef(null);
    const [focusedDiv, setFocusedDiv] = useState(0); 
    const [manifestContainerdisable, setmanifestContainerdisable] = useState(false); 
    const [upperdivFocusDisable, setupperdivFocusDisable] = useState(false);
    const [releasefooter, setreleasefooter] = useState(true);
    const [activeleftChildIndex, setActiveleftChildIndex] = useState(0);
    const IsModulAndLoginDivDisabled = useSelector(state => state.login.IsModulAndLoginDivDisabled);

    const notify = (e, close = 5000) =>
    toast.error(e, {
      position: "top-right",
      autoClose: close,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const Location = useSelector(state => state.login.Location);
    const [triggerModal, settriggerModal] = useState(false);
    const [sortBy, setsortBy] = useState('BoardingSequenceNumber');
    const [view, setViewBy] = useState('Manifested');
    const [selectAllPassenger, setselectAllPassenger] = useState(false);
    const [unchecked, setunchecked] = useState(true);
    const [board, setboard] = useState(true);
    const [unboard, setunboard] = useState(true);
    const [reload, setReload] = useState(false);
    const flightManifest = useSelector(state => state.flightSearch.flightManifestBoarding);
    const selectedLeg = useSelector(state => state.flightSearch.selectedFlight);
    const displayEconomymanifest = flightManifest && flightManifest.cabinPassengerCounts.filter(cc => cc.cabinOfService === 'Y');

    // console.log('histtoory', history);

    
    const [passengerList, setPassengerList] = useState(flightManifest.passengerList.length ? flightManifest.passengerList : []);
    // console.log('passengerList', getSegmentsDetail(flightManifest.market,'liftStatus', passengerList.find(p => p.recordLocator === 'DHFZUB'))) //passengerList.find(p => p.recordLocator === 'DHFZUB'));
    useEffect(() => {
        if (selectAllPassenger && passengerList.every((pax) => getSegmentsDetail(flightManifest.market,'liftStatus', pax) === 1)) {
            setunchecked(false);
            setboard(false);
        }
        else if (selectAllPassenger && passengerList.every((pax) => getSegmentsDetail(flightManifest.market,'liftStatus', pax) === 2)) {
            setunboard(false);
        } else {
            setunchecked(true);
            setboard(true);
            setunboard(true);
        }
    }, [selectAllPassenger]);

    useEffect(() => {
        if (selectedLeg && flightManifest) {
            document.addEventListener("keydown", shortcutKeyHandler);
        }

        // cleanup this listener
        return () => {
            document.removeEventListener('keydown', shortcutKeyHandler);
        };
    }, [selectedLeg, flightManifest]);

    const shortcutKeyHandler = (e) => { 
        // debugger
        if (e.key && shortcutKeysBoarding.includes(e.key)) {
            const path = shortcutKeyForBoardingsPage(location.pathname,e);
            if (path) {
                history.push('/' + path);    
            } 
        }
    }

    useEffect(() => {
        debugger
        ( async () => {
            try {
                const manifestData = await fncLoadFlightManifestDataForBoarding(selectedLeg);
                const tripData = await fncGetTripStatus(selectedLeg);
                if ((manifestData.status == "401" && manifestData.data == "") ||  (tripData.status == "401" && tripData.data == "")) {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    //notify(returnVal.statusText);
                    settriggerModal(true);
                } else {
                    if (!manifestData.data.isError) {
                        const { passengerList } = manifestData.data.data;
                        const mapAndCountByRecordLocator = mapToProp(passengerList, 'recordLocator');
                        passengerList.length && passengerList.forEach(pax => {
                            pax.isChecked = false;
                            pax.isSelectedForSeatAssign = false;
                            pax.recordLocatorCount = mapAndCountByRecordLocator[pax.recordLocator] === 1 ? '' : `1/${mapAndCountByRecordLocator[pax.recordLocator]}`;
                        });
                        const sortedPaxList = [...passengerList];
                        sortedPaxList.sort(function (a, b) {
                            const seqNumber1 = getSegmentsDetail(flightManifest.market,'boardingSequence', a);
                            const seqNumber2 = getSegmentsDetail(flightManifest.market,'boardingSequence', b);
                            let comparison = 0;
        
                            if (seqNumber1 > seqNumber2) {
                                comparison = 1;
                            } else if (seqNumber1 < seqNumber2) {
                                comparison = -1;
                            }
                            return comparison;
                        })
                        setPassengerList(sortedPaxList);
                        dispatch(flightManifestBoardingCredential(
                            {
                                type: '',
                                flightManifestBoarding: manifestData.data.data
                            }
                        ))

                    } else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        notify(manifestData.data.errorDetail.errorMessage);
                    }

                    if (!tripData.data.isError) {
                        const { destinationDetails, operationDetails, originDetails, irop } = tripData.data;
                        dispatch(flightTripBoardingCredential(
                            {
                                type: '',
                                flightTripBoarding: { destinationDetails, operationDetails, originDetails, irop }
                            }
                        ))
                    } else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        notify(tripData.data.errorDetail.errorMessage);
                    }
                    // window.location.reload();
                    // setReload(true);
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    // dispatch(setflightLegKeyCredential({
                    //     type: '',
                    //     selectedFlight: selectedFlight.legKey
                    // }));
                    // const navPage = pageNavigationForBoardingModule('FlightSearch');
                    // history.push("/"+navPage);          
                }
            } catch (e) {
                console.log('error in loading flight data', e);
                document.getElementById("showAndHideSpinner").style.display = "none";
                notify(e.message);
            }
        })();
    }, []);

    useEffect(() => {
        debugger
        const passengers = [...passengerList]; 
        const selectedPassengers = passengers.filter(pax => pax.isChecked);
        // console.log('selectedPassengers', selectedPassengers);
        if (selectedPassengers.length) {
            if (selectedPassengers.length === 1) {
                if (getSegmentsDetail(flightManifest.market,'liftStatus', selectedPassengers[0]) === 1) {
                    setunchecked(false);
                    setboard(false);
                }
                else if (getSegmentsDetail(flightManifest.market,'liftStatus', selectedPassengers[0]) === 2) {
                    setunboard(false);
                }
            } else {
                if (selectedPassengers.every((pax) => getSegmentsDetail(flightManifest.market,'liftStatus', pax) === 1)) {
                    setunchecked(false);
                    setboard(false);
                }
                else if (selectedPassengers.every((pax) => getSegmentsDetail(flightManifest.market,'liftStatus', pax) === 2)) {
                    setunboard(false);
                }
                else {
                    setunchecked(true);
                    setboard(true);
                    setunboard(true);
                }
            }
        } else {
            if (!selectAllPassenger) {
                setunchecked(true);
                setboard(true);
                setunboard(true);
            }
        }
    }, [passengerList]);

    useEffect(() => {
        let viewPaxList = [...flightManifest.passengerList];
        switch(view) {
            case 'Manifested':
                viewPaxList = [...viewPaxList];
                break;
            case 'CheckedIn':
                viewPaxList = viewPaxList.filter((pax) => getSegmentsDetail(flightManifest.market,'liftStatus', pax) === 1);
                break
            case 'NoShow':
                viewPaxList = viewPaxList.filter((pax) => getSegmentsDetail(flightManifest.market,'liftStatus', pax) === 3);
                break
            case 'Boarded':
                viewPaxList = viewPaxList.filter((pax) => getSegmentsDetail(flightManifest.market,'liftStatus', pax) === 2);
                break
            case 'Standby':
                viewPaxList = viewPaxList.filter((pax) => getSegmentsDetail(flightManifest.market,'classOfService', pax) === 'Z');
                break
            default:
                viewPaxList = [...viewPaxList];
                break;
        }
        setPassengerList(viewPaxList);
    }, [view]);

    useEffect(() => {
        let sortedPaxList = [...passengerList];
        switch(sortBy)
        {
            case 'BoardingSequenceNumber':
                sortedPaxList.sort(function (a, b) {
                    const seqNumber1 = getSegmentsDetail(flightManifest.market,'boardingSequence', a);
                    const seqNumber2 = getSegmentsDetail(flightManifest.market,'boardingSequence', b);
                    let comparison = 0;

                    if (seqNumber1 > seqNumber2) {
                        comparison = 1;
                    } else if (seqNumber1 < seqNumber2) {
                        comparison = -1;
                    }
                    return comparison;
                });
            break;
            case 'LastName':
                sortedPaxList.sort(function (a, b) {
                    const name1 = a.name.last.toUpperCase();
                    const name2 = b.name.last.toUpperCase();
                    let comparison = 0;

                    if (name1 > name2) {
                        comparison = 1;
                    } else if (name1 < name2) {
                        comparison = -1;
                    }
                    return comparison;
                });
            break;
            case 'PNR':
                sortedPaxList.sort(function (a, b) {
                    const pnr1 = a.recordLocator.toUpperCase();
                    const pnr2 = b.recordLocator.toUpperCase();
                    let comparison = 0;

                    if (pnr1 > pnr2) {
                        comparison = 1;
                    } else if (pnr1 < pnr2) {
                        comparison = -1;
                    }
                    return comparison;
                });
            break;
            case 'SeatNumber':
                sortedPaxList.sort(function (a, b) {
                    const seat1 = getSegmentsDetail(flightManifest.market,'seat', a);
                    const seat2 = getSegmentsDetail(flightManifest.market,'seat', b);
                    if (seat1 === '') {
                        return 1;
                    } else if (seat2 === '') {
                        return -1;
                    } else {
                        return seat1.localeCompare(seat2, 'en', { numeric: true });
                    }
                });
            break;
            case 'LiftStatus':
                sortedPaxList.sort(function (a, b) {
                    const liftStatus1 = getSegmentsDetail(flightManifest.market,'liftStatus', a);
                    const liftStatus2 = getSegmentsDetail(flightManifest.market,'liftStatus', b);
                    let comparison = 0;

                    if (liftStatus1 > liftStatus2) {
                        comparison = 1;
                    } else if (liftStatus1 < liftStatus2) {
                        comparison = -1;
                    }
                    return comparison;
                });
            break;
            default:
                sortedPaxList = [...passengerList];
            break;
        }
        // if (sortBy === 'SeatNumber') {
        //     sortedPaxList.reverse();
        // }
        setPassengerList(sortedPaxList);
    }, [sortBy]);

    const displayBaggages = (pax) => {
        return (
            <div>
                <p class="grey-text font-sm mb-0" data-tip data-for={pax.passengerKey+pax.recordLocator} >{getSegmentsDetail(flightManifest.market,'baggages', pax)}</p>
                <ReactTooltip id={pax.passengerKey+pax.recordLocator} place="right" effect="solid">
                    {getSegmentsDetail(flightManifest.market,'baggages', pax)}
                </ReactTooltip>
            </div>
        )
    }

    const fncSortBy = (e) => {
        var sortValue = e.target.value;
        if (sortValue !== '') {
            setsortBy(sortValue);
        }
    }

    const fncViewOnly = (e) => {
        var viewValue = e.target.value;
        if (viewValue !== '') {
            setViewBy(viewValue);
        }
    }

    const fncSelectAllPassenger = (e) => {
        setselectAllPassenger(e.target.checked);
        // console.log('setselectAllPassenger', e.target.checked);
        const allPassenger = [...passengerList];
        debugger
        allPassenger.forEach(pax => {
            pax.isChecked = e.target.checked;
        });
        // console.log('allPassenger', allPassenger);
        setPassengerList(allPassenger);
    }

    const fncSelectPassenger = (e, pax) => {
        // console.log('e.target.checked', e.target.checked, pax);
        const passengers = [...passengerList];
        passengers.forEach((p) => {
            if (p.recordLocator === pax.recordLocator && p.passengerKey === pax.passengerKey) {
                p.isChecked = e.target.checked;
            }
        });
        setPassengerList(passengers);
    }

    const fncUncheckPassenger = async () => {
        const passengers = [...passengerList];
        const selectedPassengers = passengers.filter(pax => pax.isChecked);
        let checkInPassengerDetails = [];
        selectedPassengers.forEach(pax => {
            const flightNo  = flightManifest.market.identifier.identifier;
            const { segments } = pax.services[0];
            const currentSegment = segments.filter(s => s.market.identifier.identifier === flightNo)[0];
            checkInPassengerDetails.push({
                "segmentKey": currentSegment.segmentKey,
                "journeyKey": '',
                "passengerKeys": [{ passengerKey: pax.passengerKey }],
                "recordLocator":pax.recordLocator
            })
        })
        // console.log('checkInPassengerDetails', checkInPassengerDetails);
        try {
            const returnVal = await fncUndoCheckInPassengerApi(checkInPassengerDetails);
            if (returnVal.status == "401" && returnVal.data == "") {
                document.getElementById("showAndHideSpinner").style.display = "none";
                settriggerModal(true);
            } else {
          
                if (!returnVal.data.isError) {
                    try {
                        const manifestData = await fncLoadFlightManifestDataForBoarding(selectedLeg);
                        const tripData = await fncGetTripStatus(selectedLeg);
                        if ((manifestData.status == "401" && manifestData.data == "") ||  (tripData.status == "401" && tripData.data == "")) {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            //notify(returnVal.statusText);
                            settriggerModal(true);
                        } else {
                            if (!manifestData.data.isError) {
                                const { passengerList } = manifestData.data.data;
                                const mapAndCountByRecordLocator = mapToProp(passengerList, 'recordLocator');
                                passengerList.length && passengerList.forEach(pax => {
                                    pax.isChecked = false;
                                    pax.isSelectedForSeatAssign = false;
                                    pax.recordLocatorCount = mapAndCountByRecordLocator[pax.recordLocator] === 1 ? '' : `1/${mapAndCountByRecordLocator[pax.recordLocator]}`;
                                });
                                setPassengerList(passengerList);
                                dispatch(flightManifestBoardingCredential(
                                    {
                                        type: '',
                                        flightManifestBoarding: manifestData.data.data
                                    }
                                ))
        
                            } else {
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                notify(manifestData.data.errorDetail.errorMessage);
                            }
        
                            if (!tripData.data.isError) {
                                const { destinationDetails, operationDetails, originDetails, irop } = tripData.data;
                                dispatch(flightTripBoardingCredential(
                                    {
                                        type: '',
                                        flightTripBoarding: { destinationDetails, operationDetails, originDetails, irop }
                                    }
                                ))
                            } else {
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                notify(tripData.data.errorDetail.errorMessage);
                            }
                            // window.location.reload();
                            // setReload(true);
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            // dispatch(setflightLegKeyCredential({
                            //     type: '',
                            //     selectedFlight: selectedFlight.legKey
                            // }));
                            // const navPage = pageNavigationForBoardingModule('FlightSearch');
                            // history.push("/"+navPage);          
                        }
                    } catch (e) {
                        console.log('error in loading flight data', e);
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        notify(e.message);
                    }
                }
                else {
                  document.getElementById("showAndHideSpinner").style.display = "none";
                  notify(returnVal.data.errorDetail.errorMessage);
                //   window.location.reload();
                }
            }
        } catch (e) {
            console.log("Axios err in unchecking passengers: ", e);
        }
    }

    const fncBoardPassenger = async () => {
        const passengers = [...passengerList];
        const selectedPassengers = passengers.filter(pax => pax.isChecked);
        let boardPassengerDetails = [];
        selectedPassengers.forEach(pax => {
            boardPassengerDetails.push({
                RecordLocator: pax.recordLocator,
                PassengerKey: pax.passengerKey
            })
        })
        const apiRequest = {
            LegKey: selectedLeg,
            Passengers: boardPassengerDetails
        }

        try {
            const returnVal = await fncBoardPassengers(apiRequest);
            if (returnVal.status == "401" && returnVal.data == "") {
                document.getElementById("showAndHideSpinner").style.display = "none";
                settriggerModal(true);
            } else {
          
                if (!returnVal.data.isError) {
                    try {
                        const manifestData = await fncLoadFlightManifestDataForBoarding(selectedLeg);
                        const tripData = await fncGetTripStatus(selectedLeg);
                        if ((manifestData.status == "401" && manifestData.data == "") ||  (tripData.status == "401" && tripData.data == "")) {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            //notify(returnVal.statusText);
                            settriggerModal(true);
                        } else {
                            if (!manifestData.data.isError) {
                                const { passengerList } = manifestData.data.data;
                                const mapAndCountByRecordLocator = mapToProp(passengerList, 'recordLocator');
                                passengerList.length && passengerList.forEach(pax => {
                                    pax.isChecked = false;
                                    pax.isSelectedForSeatAssign = false;
                                    pax.recordLocatorCount = mapAndCountByRecordLocator[pax.recordLocator] === 1 ? '' : `1/${mapAndCountByRecordLocator[pax.recordLocator]}`;
                                });
                                setPassengerList(passengerList);
                                dispatch(flightManifestBoardingCredential(
                                    {
                                        type: '',
                                        flightManifestBoarding: manifestData.data.data
                                    }
                                ))
                                setViewBy('Manifested');
        
                            } else {
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                notify(manifestData.data.errorDetail.errorMessage);
                            }
        
                            if (!tripData.data.isError) {
                                const { destinationDetails, operationDetails, originDetails, irop } = tripData.data;
                                dispatch(flightTripBoardingCredential(
                                    {
                                        type: '',
                                        flightTripBoarding: { destinationDetails, operationDetails, originDetails, irop }
                                    }
                                ))
                                setViewBy('Manifested');
                            } else {
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                notify(tripData.data.errorDetail.errorMessage);
                            }
                            // setReload(true);
                            // window.location.reload();
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            // dispatch(setflightLegKeyCredential({
                            //     type: '',
                            //     selectedFlight: selectedFlight.legKey
                            // }));
                            // const navPage = pageNavigationForBoardingModule('FlightSearch');
                            // history.push("/"+navPage);          
                        }
                    } catch (e) {
                        console.log('error in loading flight data', e);
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        notify(e.message);
                    } 
                }
                else {
                  document.getElementById("showAndHideSpinner").style.display = "none";
                  notify(returnVal.data.errorDetail.errorMessage);
                //   window.location.reload();
                }
            }
        } catch (e) {
            console.log("Axios err in boarding passengers: ", e);
        }
    }

    const fncUnboardPassenger = async () => {
        const passengers = [...passengerList];
        const selectedPassengers = passengers.filter(pax => pax.isChecked);
        let unnboardPassengerDetails = [];
        selectedPassengers.forEach(pax => {
            unnboardPassengerDetails.push({
                RecordLocator: pax.recordLocator,
                PassengerKey: pax.passengerKey
            })
        })
        const apiRequest = {
            LegKey: selectedLeg,
            Passengers: unnboardPassengerDetails
        }

        try {
            const returnVal = await fncUnBoardPassengers(apiRequest);
            if (returnVal.status == "401" && returnVal.data == "") {
                document.getElementById("showAndHideSpinner").style.display = "none";
                settriggerModal(true);
            } else {
          
                if (!returnVal.data.isError) {
                    try {
                        const manifestData = await fncLoadFlightManifestDataForBoarding(selectedLeg);
                        const tripData = await fncGetTripStatus(selectedLeg);
                        if ((manifestData.status == "401" && manifestData.data == "") ||  (tripData.status == "401" && tripData.data == "")) {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            //notify(returnVal.statusText);
                            settriggerModal(true);
                        } else {
                            if (!manifestData.data.isError) {
                                const { passengerList } = manifestData.data.data;
                                const mapAndCountByRecordLocator = mapToProp(passengerList, 'recordLocator');
                                passengerList.length && passengerList.forEach(pax => {
                                    pax.isChecked = false;
                                    pax.isSelectedForSeatAssign = false;
                                    pax.recordLocatorCount = mapAndCountByRecordLocator[pax.recordLocator] === 1 ? '' : `1/${mapAndCountByRecordLocator[pax.recordLocator]}`;
                                });
                                setPassengerList(passengerList);
                                dispatch(flightManifestBoardingCredential(
                                    {
                                        type: '',
                                        flightManifestBoarding: manifestData.data.data
                                    }
                                ))
                                setViewBy('Manifested');
        
                            } else {
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                notify(manifestData.data.errorDetail.errorMessage);
                            }
        
                            if (!tripData.data.isError) {
                                const { destinationDetails, operationDetails, originDetails, irop } = tripData.data;
                                dispatch(flightTripBoardingCredential(
                                    {
                                        type: '',
                                        flightTripBoarding: { destinationDetails, operationDetails, originDetails, irop }
                                    }
                                ))
                                setViewBy('Manifested');
                            } else {
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                notify(tripData.data.errorDetail.errorMessage);
                            }
                            // setReload(true);
                            // window.location.reload();
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            // dispatch(setflightLegKeyCredential({
                            //     type: '',
                            //     selectedFlight: selectedFlight.legKey
                            // }));
                            // const navPage = pageNavigationForBoardingModule('FlightSearch');
                            // history.push("/"+navPage);          
                        }
                    } catch (e) {
                        console.log('error in loading flight data', e);
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        notify(e.message);
                    } 
                }
                else {
                  document.getElementById("showAndHideSpinner").style.display = "none";
                  notify(returnVal.data.errorDetail.errorMessage);
                //   window.location.reload();
                }
            }
        } catch (e) {
            console.log("Axios err in unboarding passengers: ", e);
        }
    }

    const getPhoneNumber = (pax) => {
        const { passengerAddresses } = pax;
        const number = passengerAddresses.length && passengerAddresses[0].phone ? passengerAddresses[0].phone : '';
        return number;
    }

    const getInfantInfo = (pax) => {
        let infantName = ' ';
        if (pax.infant) {
            infantName = `${pax.infant.name.last}, ${pax.infant.name.first} ${pax.infant.name.title ? pax.infant.name.title : ''}`;
        }
        return infantName;
    }


// update
    const handleKeyDown = (e) => {  };

    useEffect(() => {
        debugger
           const handleKeyDown = (e) => {
            if (e.altKey && e.key.toLowerCase() === 'c') {
                                    if(!IsModulAndLoginDivDisabled){
                                        setupperdivFocusDisable(false);
                                        dispatch(moduleAndLoginDivDisabled({
                                            type: "MODULE_AND_LOGINDIV_DISABLED",
                                            IsModulAndLoginDivDisabled: true
                                        }));
                                        fncFocusElementDependsOnPathLocation(location.pathname,seatmanagementsortref.current);
                                    }else if (IsModulAndLoginDivDisabled) {
                                        setmanifestContainerdisable(true);
                                        setupperdivFocusDisable(true);

                                                                        const headingDiv = document.querySelector(".modulebtn");            
                                                                        if (headingDiv) {                  
                                                                            headingDiv.focus();
                                                                            dispatch(moduleAndLoginDivDisabled({
                                                                                    type: "MODULE_AND_LOGINDIV_DISABLED",
                                                                                    IsModulAndLoginDivDisabled: false
                                                                                }));
                                                                        }
                                                                    }
            }
        else if (e.shiftKey && e.key === "ArrowUp") {
            if(focusedDiv === 0){
                setupperdivFocusDisable(true);
                setreleasefooter(false);
                setFocusedDiv(2);
             e.preventDefault(); 
             bordorunboardref.current.focus();
            }  else
            if(focusedDiv === 1){
                setupperdivFocusDisable(false);
                setFocusedDiv(0);
             e.preventDefault(); 
               seatmanagementsortref.current.focus();
        }  
            if(focusedDiv === 2){
                    if(passengerList.length > 0){
                    setFocusedDiv(1);
                    setreleasefooter(true)
                    e.preventDefault(); 
                    allselectref.current.focus();  
                }else {
                    setupperdivFocusDisable(false);
                    setreleasefooter(true)
                    setFocusedDiv(0);
                    e.preventDefault(); 
                seatmanagementsortref.current.focus();
                }
            }  
           }
          if (e.shiftKey && e.key === "ArrowDown") {
            if (!passengerList.length) return;
                setActiveleftChildIndex(0);
                if(focusedDiv === 1){
                    setreleasefooter(false)
                    setFocusedDiv(2);
                    e.preventDefault();
                    bordorunboardref.current.focus();
            }       
            else if(focusedDiv === 0 ){  
                    if(passengerList.length > 0){ 
                        setupperdivFocusDisable(true);
                        setFocusedDiv(1);
                        e.preventDefault();
                        allselectref.current.focus(); 
                    }else {
                        setupperdivFocusDisable(true);
                        setreleasefooter(false)
                        setFocusedDiv(2);
                        e.preventDefault();
                        bordorunboardref.current.focus();
                    } 
            }              
            else if(focusedDiv === 2){  
                setreleasefooter(true);
                setupperdivFocusDisable(false);
                setFocusedDiv(0);
                e.preventDefault();
                seatmanagementsortref.current.focus();            
               }
            }
             else  if (e.key === "ArrowUp") {
                if(focusedDiv === 1){
                    setActiveleftChildIndex((prevIndex) => {
                        const newIndex = Math.max(prevIndex - 1, 0);
                        const targetDiv = inputElementForSeat.current[newIndex];
                        if (targetDiv) {
                        targetDiv.focus();              
                        const checkboxes = Array.from(targetDiv.querySelectorAll("input[type='checkbox']"));        
                        }
                        return newIndex;
                    });
                 } 
                }
                 else 
                 if (e.key === "ArrowDown" ) {
              
                  if(focusedDiv === 1){
                    e.preventDefault();
                   //  debugger
                    setActiveleftChildIndex((prevIndex) => {
                      const rows = inputElementForSeat.current;
                     const newIndex = Math.min(prevIndex + 1, rows.length-1);
                     const targetDiv=inputElementForSeat.current[newIndex];
                     if (targetDiv) {
                      targetDiv.focus();              
                      const checkboxes = Array.from(targetDiv.querySelectorAll("input[type='checkbox']"));
                    
                    }
                     return newIndex;
                    });
                    }
                  } 
           };
   
           document.addEventListener("keydown", handleKeyDown);
           return () => {
               document.removeEventListener("keydown", handleKeyDown);
           };
       }, [focusedDiv,passengerList,upperdivFocusDisable, IsModulAndLoginDivDisabled]);

       useEffect(() => {
        if ( inputElementForSeat.current[activeleftChildIndex]) {
               inputElementForSeat.current[activeleftChildIndex].focus();}
     },[activeleftChildIndex]);
       const trapFocus4 = (e, divIndex, ref) => {
        const currentDiv = ref.current[divIndex];
        if (!currentDiv) return;
      
        // Get all focusable elements inside the div
        const focusableElements = Array.from(
          currentDiv.querySelectorAll(
            "input, button, textarea, a[href], [tabindex]:not([tabindex='-1'])"
          )
        );
      
        if (focusableElements.length === 0) return; // No focusable elements, do nothing
      
        // const firstElement = focusableElements[0];when we press shift+Tab it is loosing focus  focused div  
        // const firstElement = focusableElements[1]; //making 0 to 1 when we press shift+Tab it is traping focus inside rightside focused div but loosing focus to leftside div input 
        const firstElement = focusableElements[0]
        const lastElement = focusableElements[focusableElements.length - 1];
      
        if (e.key === "Tab") {
          // if (e.shiftKey && document.activeElement === firstElement) {
          //   // If Shift+Tab is pressed on first element, move focus to last
          //   e.preventDefault();
          //   lastElement.focus();
          // } 
          // else
          //  if (!e.shiftKey && document.activeElement === lastElement) {
           if ( document.activeElement === lastElement) {
            // If Tab is pressed on last element, move focus to first
            e.preventDefault();
            firstElement.focus();
          }
         
        }
         if (e.shiftKey && e.key === "Tab" ) {
          if (document.activeElement === firstElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      };
    return (
        <div inert>
            <LogoutModel trigger={triggerModal}> </LogoutModel>
            <div class="full-container">
            <FocusLock 
            disabled={manifestContainerdisable}
            >

            <div class="boarding-container mt-3">
            <div class="card boarding-card fixedBtn">
                <div class="heading mb-3 headingWithRightContent">
                    <h4 class="font-xxl bold dark-text mb-0">
                        Manifest 
                    </h4>
                    <FocusLock disabled={upperdivFocusDisable}>
                    <div class="right-filter">
                        <div class="form-group form-floating me-4">
                            <select ref={seatmanagementsortref} class="form-control focusClass" required="" value={view} onChange={e => fncViewOnly(e)} id="view" aria-label="view">
                                <option value="Manifested">Manifested ({displayEconomymanifest.length && displayEconomymanifest[0].manifested})</option>
                                <option value="CheckedIn">Checked In</option>
                                <option value="Boarded">Boarded</option>
                                <option value="NoShow">No Show</option>
                                <option value="Standby">Stand-by</option>
                            </select>
                            <label class=" dark-text" htmlFor="view">View</label>
                        </div>
                        <div class="form-group form-floating  me-4">
                            <select class="form-control focusClass" required="" value={sortBy} onChange={e => fncSortBy(e)} id="sortBy" aria-label="sortBy">
                                <option value="BoardingSequenceNumber">Boarding Sequence Number</option>
                                <option value="LastName"> Last Name</option>
                                <option value="PNR">PNR</option>
                                <option value="SeatNumber">Seat Number</option>
                                <option value="LiftStatus">Lift Status</option>
                            </select>
                            <label class=" dark-text" htmlFor="sortBy">Sort By</label>
                        </div>
                        <button class="btn icon-btn btn-outline-primary px-2 SerachBtn">
                            <img class="icon-28" src="newImages/icon-printer.svg" alt="printer"/>
                        </button>
                    </div>
                    </FocusLock>
                </div>
                <div class="manifest-table">
                    <div class="ptable-data">
                        <div class="headings" tabIndex={-1}>
                            {
                                passengerList && passengerList.length ?
                                <div class="checkbox checkbox-input">
                                    <input ref={allselectref} class="me-2 form-check-input checkbox-input" type="checkbox" checked={selectAllPassenger} onChange={(e) => { fncSelectAllPassenger(e)}} id="selectAll" name="selectAll" />
                                </div> : null
                            }
                            <div class="manifest-userIcon" tabIndex={-1}></div>
                            <div class="name">Name</div>
                            <div class="pnr">PNR</div>
                            <div class="phoneNo">Phone No.</div>
                            <div class="seat-count">Seat</div>
                            <div class="seq">Seq</div>
                            <div class="bags">Bags</div>
                            <div class="destination">Destination</div>
                            <div class="info"></div>
                        </div>
                        <div class="pTable-scroll-body mb-0">
                        {
                            passengerList && passengerList.length ? passengerList.map((pax, i) =>
                                <div>
                                    <div class="table-item checkbox-input"
                                    key={i} 
                                    ref={(el) => (inputElementForSeat.current[i] = el)}
                                    tabIndex={-1} 
                                   onKeyDown={(e) => {                                                              
                                         handleKeyDown(e); 
                                          if (activeleftChildIndex === i) { 
                                             trapFocus4(e, i,inputElementForSeat);
                                               }   
                                         }  }                                                          
                                        >
                                        <div class="checkbox">
                                            <input class="me-2 form-check-input OrangeShadow" type="checkbox" checked={pax.isChecked} onChange={(e) => { fncSelectPassenger(e, pax)}} id="select1" name="select1"/><span class="font-sm">{pax.recordLocatorCount}</span>
                                        </div>
                                        <div class="manifest-userIcon">
                                            <img src={getIconForPassenger(pax, flightManifest)} alt="manifest-userIcon"/>
                                        </div>
                                        <div class="name">
                                            <label>Name</label>
                                            <p data-tip data-for={pax.passengerKey+pax.recordLocator+pax.name.first+'forInfant'}>{`${pax.name.last}, ${pax.name.first} ${pax.name.title ? pax.name.title : ''}`}</p>
                                            {
                                                pax.infant ?
                                                <ReactTooltip id={pax.passengerKey+pax.recordLocator+pax.name.first+'forInfant'} place="bottom" effect="solid">
                                                    {getInfantInfo(pax)}
                                                </ReactTooltip> : null
                                            }
                                        </div>
                                        <div class="pnr">
                                            <label>PNR</label>
                                            <p>{pax.recordLocator}</p>
                                        </div>
                                        <div class="phoneNo"> <label>Phone No.</label>
                                            <p>{getPhoneNumber(pax)}</p>
                                        </div>
                                        <div class="seat-count"> <label>Seat</label>
                                            <p>{getSegmentsDetail(flightManifest.market,'seat', pax)}</p>
                                        </div>
                                        <div class="seq"> 
                                            <label>Seq</label>
                                            <p>{getSegmentsDetail(flightManifest.market,'boardingSequence', pax)}</p>
                                        </div>
                                        <div class="bags">
                                            <label>Bags</label>
                                            <p>{getSegmentsDetail(flightManifest.market,'bagscount', pax)}</p>
                                        </div>
                                        <div class="destination">
                                            <label>Destination</label>
                                            <p>{flightManifest.market.destination}</p>
                                        </div>
                                        <div class="info">
                                            <button class="btn info-btn OrangeShadow" data-bs-toggle="collapse" href={`#collapseExample${i}`} role="button" aria-expanded="false" aria-controls="collapseExample">
                                                <img src="newImages/info-icon.svg" alt="info"/>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="collapse collapse-table" id={`collapseExample${i}`}>
                                        <div class="manifest-table">
                                            <div class="manifest-comments">
                                                <p class="bold font-sm mb-1">Manifest Comments ({pax.comments.length})</p>
                                                {
                                                    pax.comments.length ?
                                                    <div>
                                                    {/* <p class="grey-text font-sm mb-0">Dear Mr. Thakur, Lorem ipsum dolor sit amet, consectetur adipiscing... <a class="btn-link">more</a></p> */}
                                                    {
                                                        pax.comments.map(item =>
                                                            <div>
                                                                <p class="grey-text font-sm " >{item.comment}</p>
                                                                <p class="grey-text font-sm"><i>{moment(item.date).format('DD MMM YYYY, HH:mm')}</i></p>
                                                            </div>
                                                        )
                                                    }
                                                    {/* <p class="grey-text font-sm mb-0" >{pax.comments[0].comment}</p>
                                                    <p class="grey-text font-sm mb-0"><i>{moment(pax.comments[0].date).format('DD MMM YYYY, HH:mm')}</i></p> */}
                                                    {/* <ReactTooltip id={pax.comments[0].comment} place="top" effect="solid">
                                                        {
                                                            pax.comments.map(item =>
                                                                <div>
                                                                    <p class="grey-text font-sm mb-0" >{item.comment}</p>
                                                                    <p class="grey-text font-sm mb-0"><i>{moment(item.date).format('DD MMM YYYY, HH:mm')}</i></p>
                                                                </div>
                                                            )
                                                        }
                                                    </ReactTooltip> */}
                                                    </div>
                                                    : null
                                                }
                                            </div>
                                            <div class="bag">
                                                <p class="bold font-sm mb-1">Bag({getSegmentsDetail(flightManifest.market,'bagscount', pax)})</p>
                                                {displayBaggages(pax)}
                                            </div>
                                            {/* <div class="checked"> 
                                                <p class="bold  font-sm mb-1"></p>
                                                <p class="grey-text font-sm mb-0">+STND Checked</p>
                                            </div> */}
                                            <div class="ssr"> 
                                                <p class="bold font-sm mb-1">SSRs({getSegmentsDetail(flightManifest.market,'ssrsCount', pax)})</p>
                                                <p class="grey-text font-sm mb-0" data-tip data-for={pax.passengerKey+pax.recordLocator+'ssr'}>{getSegmentsDetail(flightManifest.market,'ssrs', pax)}</p>
                                                <ReactTooltip id={pax.passengerKey+pax.recordLocator+'ssr'} place="bottom" effect="solid">
                                                    {getSegmentsDetail(flightManifest.market,'ssrs', pax)}
                                                </ReactTooltip>
                                            </div>
                                        </div>   
                                    </div>
                                </div>
                            ) : <div className="noresultErrormessageForManifest"> No result found. Please refine your search terms</div>
                        }
                        </div>
                    </div>
                </div>    
<FocusLock disabled={releasefooter}>
                <div class="btn-container justify-content-end d-flex OrangeShadow" tabIndex={-1} ref={bordorunboardref}>
                    {/* <button class="btn btn-primary me-4" onClick={()=>{fncUncheckPassenger()}} disabled={unchecked}>
                        <span class="px-4">Uncheck</span>
                    </button> */}
                    <button class="btn btn-primary me-4 SerachBtn" tabIndex={0} onClick={()=>{fncUnboardPassenger()}} disabled={unboard}>
                        <span class="px-4">Unboard</span>
                    </button>
                    <button class="btn btn-primary SerachBtn" tabIndex={0} onClick={()=>{fncBoardPassenger()}} disabled={board}>
                        <span class="px-4">Board</span>
                    </button>
                    
                </div>  
                </FocusLock>   
            </div>  


            
        </div>
        </FocusLock>

        </div>
        </div>
    )
}

export default Manifest;